export const incomingRequests = {

  "title": "Inteligentne dopasowanie",
  "subtitle": "Odkryj członków, którzy chcą odwiedzić Twój region",
  "requests": {
    "title": "Prośby",
    "count": "{{count}} prośba(y)",
    "empty": {
      "noListingDescription": "Nie masz jeszcze ogłoszenia. Opublikuj je, aby otrzymywać prośby."
    },
    "loading": "Ładowanie próśb...",
    "errors": {
      "notAuthenticated": "Musisz się zalogować, aby wyświetlić tę stronę.",
      "loadFailed": "Wystąpił błąd podczas ładowania próśb."
    },
    "defaultPropertyType": "Zakwaterowanie",
    "sortOptions": {
      "recent": "Najnowsze",
      "rating": "Najlepiej oceniane",
      "distance": "Bliższy"
    }
  },
  "aiSection": {
    "title": "Inteligentne sugestie",
    "subtitle": "Odkryj członków pasujących do Twoich kryteriów",
    "distance": "Odległość",
    "dates": "Daty",
    "guests": "Podróżni",
    "matchScore": "Wynik dopasowania",
    "search": "Szukaj",
    "startDiscussion": "Rozpocznij dyskusję",
    "viewProfile": "Zobacz profil",
    "away": "odległości"
  }
};
